module.exports = __webpack_public_path__ + "img/2-2.0d96f7fd.svg";